<p-toast *ngIf="!commonService.isMobileView" position="top-right"></p-toast>
<p-toast position= "top-right" [breakpoints]="{'991px': {width: '100%', right: '0', left: '0'}}" *ngIf="commonService.isMobileView"></p-toast>
<div class="modal-header d-flex" [ngClass]="{'justify-content-center': isMerchantBilling || centerHeader}">
    <div class="row thumbs_icon" [class.w-100]="centerHeader" [class.justify-content-center]="centerHeader">
        <div [class.ml-2]="!centerHeader">
            <h5 class="modal-title" [class.text-center]="centerHeader" [class.w-100]="centerHeader" id="exampleModalLongTitle"><span
                    class="font-weight-bold text_baseline" [ngStyle]="centerHeader ? {'font-size': '1.25rem'} : {}">{{isMerchantBilling ? 'Add-on Features' : header}}</span>
            </h5>
        </div>
    </div>

    <!-- Close Button -->
    <button type="button" class="close ml-auto" aria-label="Close" *ngIf="isShowCloseButton" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body text-center px-3 py-3" *ngIf="!isLoading">

    <div *ngIf="successFlag">

        <!-- <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#10b759" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <polyline class="path check" fill="none" stroke="#10b759" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg> -->
        <svg style="width: 100px; height: 100px" version="1.1" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#10b759" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
            <polyline class="path check" fill="none" stroke="#10b759" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
    </div>
    <div *ngIf="negativeFlag">
        <svg style="width: 100px; height: 100px" version="1.1" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#ff3366" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
            <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
            <line class="path line" fill="none" stroke="#ff3366" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
    </div>
    <h5 class="text-center mt-2 mb-2" [class.info-modal-compact-body]="compactBody">{{body}}
        <div class="mt-2 mb-1 text-center" [innerHTML]="htmlContent"></div>
    </h5>
    <ng-container *ngIf="isMerchantBilling">
        <h5 class=" mt-2 mb-1 text-left ml-4">Would you like to enable the following features?</h5>
        <ul class="text-left">
            <ng-container *ngFor="let item of addOnFeatureList">
                <li>
                    <h5 class=" mt-2 mb-1"><label>{{item}}</label></h5>
                </li>
            </ng-container>
        </ul>
    </ng-container>
    
    <div *ngIf="showWarning" class="mt-3 w-100">
      <p-message severity="warn" text="Deleting will remove logos from all the assigned TPN(s)"> </p-message>
      <div class="mt-3">
        <textarea [value]="tpnsListForDeletion.join(', ')" rows="3" class="w-100 rounded p-1 bg-light" readonly> </textarea>
      </div>
    </div>
    <div *ngIf="negativeFlag">
        <b>Reason:</b> <span>
            <p class="text-center mt-2 mb-1">{{message}}</p>
        </span>
    </div>
    <div [ngStyle]="increaseBodyContentSize" *ngIf="innerHtmlContent != ''" [innerHTML]="innerHtmlContent">
    </div>
    <div *ngIf="editPriorityId">
        <form [formGroup]="customerForm" autocomplete="off">
            <div class="container" formGroupName="customerInfo">
                <div class="row">
                    <label class="label_align" for="priorityId">
                        {{ 'htmlText.priorityId' | translate }}
                    </label>
                    <input type="text" class="form-control floating-input" placeholder=" Enter Priority Id" formControlName="priorityId"
                        trim="blur" maxlength="12" />
                </div>
        
                <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="customerForm.get(['customerInfo','priorityId']).errors?.hasAlphaNumeric">
                    {{'errorMsg.serialNumberalphanumericRequired' | translate}}
                </ngb-alert>
                <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="customerForm.get(['customerInfo','priorityId']).errors?.hasMaxpriorityLength &&
                                !customerForm.get(['customerInfo','priorityId']).errors?.hasAlphaNumeric">
                    {{'errorMsg.priorityLength' | translate}}
                </ngb-alert>
            </div>
        </form>
    </div>
    <div *ngIf="showEmail" class="form-group">
        <input type="email" class="form-control" placeholder="Enter email" [formControl]="emailControl" required>
        <div *ngIf="emailControl.invalid && emailControl.touched" class="text-danger">
            Please enter a valid email
        </div>
    </div>
</div>
<app-loading *ngIf="isLoading" [loaderHeight]="'medium'"> </app-loading>
<div class="modal-footer pb-2">
    <div class="text-right m-1" *ngIf="okButton">
        <button (click)="onOkClick();" *ngIf="okButton" [disabled]="spinLoader" class="mt-2 text-right btn btn-primary mr-2">
            <span *ngIf="spinLoader" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
            {{okBtnLabel | translate}}</button>
    </div>

    <!-- <div class="text-right m-1" *ngIf="cancelButton">
    </div> -->
    <div class="text-right m-1" *ngIf="commitButton">
        <button (click)="modal.close();" class="mt-2 text-right btn btn-danger mr-2">Cancel</button>
        <button (click)="commitInvoice()" class="mt-2 text-right btn btn-primary mr-2" [disabled]="spinLoader">
            <span *ngIf="spinLoader" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>{{commitButtonText}}</button>
    </div>
    <div class="text-right m-1" *ngIf="gotoButton">
        <button (click)="modal.close();" class="mt-2 text-right btn btn-primary mr-2">OK</button>
        <button (click)="modal.close();"class="mt-2 text-right btn btn-primary mr-2" [disabled]="disableButton" 
                    [queryParams]="goToQueryParams" [routerLink]="goToRoute">{{buttonName}}
        </button>
    </div>
    <div  class="text-right m-1" *ngIf="enableISOLogo">
        <button (click)="modal.close('close');" (mousedown)="$event.preventDefault()" class="text-right btn btn-danger mr-2" [disabled]="spinLoader">Cancel</button>
        <button *ngIf="enableRoutingButton" [disabled]="spinLoader" (click)="modal.close('goToBatches')" [routerLink]="'/batch-management/batches'" class="text-right btn btn-secondary mr-2" [queryParams]="queryParam">Go To Batches</button>
        <button *ngIf="!onlyCancelButton" (click)="deleteISOLogo()" class="text-right btn btn-primary mr-2" [disabled]=" showEmail ? isDisabled() : spinLoader">
            <span *ngIf="spinLoader" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span> {{buttonNameIso}}</button>
    </div>
    <div class="text-right m-1" *ngIf="enable2buttons">
        <button (click)="modal.close('close');" class="text-right btn btn-danger mr-2">{{this.isMerchantBilling ? 'Skip' :closeBtnName}}</button>
        <button (click)="modal.close('success')" class="text-right btn btn-primary mr-2">
            {{this.isMerchantBilling ? 'Proceed' : buttonName}}</button>
    </div>
    <div class="text-right m-1" *ngIf="proceedBtn">
        <button (click)="modal.close('close');" class="mt-2 text-right btn btn-danger mr-2">Cancel</button>
        <button (click)="proceedTest()" class="mt-2 text-right btn btn-primary mr-2" [disabled]="spinLoader">
            <span *ngIf="spinLoader" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>{{btnNamePreceed}}</button>
    </div>
    <div class="text-right m-1" *ngIf="editPriorityId">
        <button (click)="modal.close('close');" class="text-right btn btn-danger mr-2">{{closeBtnName}}</button>
        <button (click)="closePriorityModal()" [disabled] = "!customerForm.get(['customerInfo','priorityId']).value || customerForm.get(['customerInfo','priorityId']).errors?.hasMaxpriorityLength ||
        customerForm.get(['customerInfo','priorityId']).errors?.hasAlphaNumeric" class="text-right btn btn-primary mr-2">
            {{buttonName}} </button>
    </div>
</div>